// WelcomeMessageCard — mensagem de acolhimento (contrato v1.1, Parte 4).
// Consome /api/welcome-message?status= via backend (proxy resiliente).
// 404 ou erro = silêncio total. Versículo ausente = exibe só title/body.
import React, { useEffect, useState } from "react";
import { api } from "../lib/api";
import { getCompletionsCount } from "../lib/dailyJourney";

export const WelcomeMessageCard = () => {
  const [msg, setMsg] = useState(null);
  useEffect(() => {
    let alive = true;
    const load = async () => {
      let recorrente = getCompletionsCount() > 0;
      try {
        const st = await api.get("/journey/devotional-status");
        if (st.data?.has_any) recorrente = true;
      } catch { /* anônimo/offline: usa heurística local */ }
      const status = recorrente ? "recorrente" : "novo_convertido";
      try {
        const r = await api.get("/welcome-message", { params: { status } });
        const m = r.data?.message || r.data;
        if (alive && m && m.title && m.body) setMsg(m);
      } catch { /* 404/erro: silêncio total */ }
    };
    load();
    return () => { alive = false; };
  }, []);
  if (!msg) return null;
  return (
    <section
      className="mt-6 rounded-2xl bg-[hsl(var(--parchment))] border border-gold/25 p-5 sm:p-6"
      data-testid="dashboard-welcome-message"
    >
      <p className="text-[10px] uppercase tracking-[0.3em] text-gold">Acolhimento</p>
      <p className="mt-1.5 font-display text-xl sm:text-2xl text-navy leading-snug" data-testid="welcome-message-title">
        {msg.title}
      </p>
      <p className="mt-2.5 text-navy/80 text-sm sm:text-[15px] leading-[1.75]" data-testid="welcome-message-body">
        {msg.body}
      </p>
      {msg.verse_text && (
        <p className="mt-3 text-navy/75 italic text-sm leading-[1.7]" data-testid="welcome-message-verse">
          "{msg.verse_text}"
          {msg.verse_reference && (
            <span className="not-italic text-xs uppercase tracking-widest text-navy/55 ml-2 tabular-nums">
              {msg.verse_reference}
            </span>
          )}
        </p>
      )}
    </section>
  );
};
